exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.company-dropdown[data-v-5dce3c2f] {\r\n    width: 100%;\n}\n.company-dropdown .vs__dropdown-toggle[data-v-5dce3c2f] {\r\n    min-height: 38px;\n}\r\n", ""]);

// exports
